var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.randomId}),_c('Alert'),_c('div',{staticClass:"fixed bottom-2 left-2 z-30",staticStyle:{"font-size":"5px","color":"#c0c0c0"}},[_vm._v(" v"+_vm._s(_vm.version)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }